<template>
  <div>
    <filter-toolbar
      :hasChanges="hasChanges"
      :appliedFilters="appliedFilters"
      @search="search"
      @update="update"
      @clear="clear">
      <remote-facet-filter
        class="border-b"
        v-model="filters.facets.connection_id"
        response-type="object"
        :resourceLabel="(context.isSupplier()) ? 'retailer.name' : 'brand.name'"
        :filter="filterOptions.connection"
        :endpoint="context.route + '/connections/?short=1'"
        @input="change"
      />
      <facet-filter
        class="border-b"
        v-model="filters.facets.reason_id"
        :filter="filterOptions.reason"
        @input="change"
      />
      <facet-filter
        class="border-b"
        v-model="filters.facets.canceled_by"
        :filter="filterOptions.canceledBy"
        @input="change"
      />
      <boolean-filter
        class="border-b"
        v-model="filters.facets.is_acknowledged"
        :filter="filterOptions.acknowledged"
        @input="change"
      />
      <date-filter
        v-model="filters.timestamps.created_at"
        :filter="filterOptions.createdAt"
        @input="change"
      />
    </filter-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as filterOptions from '../../filters/cancels.js'
import FilterToolbar from '@/components/Filters/FilterToolbar'
import BooleanFilter from '@/components/Filters/BooleanFilter'
import DateFilter from '@/components/Filters/DateFilter'
import FacetFilter from '@/components/Filters/FacetFilter'
import RemoteFacetFilter from '@/components/Filters/RemoteFacetFilter'

export default {
  components: {
    BooleanFilter,
    DateFilter,
    FacetFilter,
    FilterToolbar,
    RemoteFacetFilter
  },
  data () {
    return {
      hasChanges: false,
      filters: null,
      // filters
      filterOptions: filterOptions
    }
  },
  computed: {
    ...mapGetters(['context'])
  },
  methods: {
    change () {
      this.hasChanges = true
    },
    search (searchQuery) {
      this.filters.search = {
        parameter: 'search',
        query: searchQuery
      }
      this.$emit('filter', this.filters)
    },
    update () {
      this.hasChanges = false
      this.filters.preset = 'custom'
      this.$emit('filter', this.filters)
    },
    clear () {
      this.filters = {
        preset: 'all',
        facets: {},
        search: {},
        timestamps: {}
      }
      this.$emit('filter', this.filters)
    }
  },
  mounted () {

  },
  props: {
    appliedFilters: {
      type: Object,
      required: true
    }
  },
  watch: {
    appliedFilters: {
      deep: true,
      immediate: true,
      handler (filters) {
        this.filters = filters
      }
    }
  }
}
</script>
